import React, { useState } from "react";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

function Dropdown(props) {
  const [isOpen, setIsOpen] = useState(false);
  function toggleIcon() {
    setIsOpen(!isOpen);
  }
  return (
    <div class=" w-full md:w-full 2xl:w-full ">
      <details
        onClick={toggleIcon}
        class=" open:ring-1 open:ring-black/5   p-3 "
        close
      >
        <summary class=" leading-6 flex justify-between text-xl md:text-[20px] text-[#FFFAFA] tracking-tight letter-spacing:-0.05em  select-none">
          <p className={isOpen ? `text-white` : `text-[#747397]`}>
            {props.title}
          </p>
          {!isOpen ? (
            <IoIosArrowDown className="ml-1 text-[#646AFB]" size={20} />
          ) : (
            <IoIosArrowUp className="ml-1 text-[#FFFBFB] " size={20} />
          )}
        </summary>
        <div class="mt-3 text-sm leading-6 tracking-tight letter-spacing:-0.05em text-slate-600 dark:text-slate-400">
          <p>{props.detail}</p>
        </div>
      </details>
    </div>
  );
}

export default Dropdown;
